import { capitalize } from "common/utils/strings";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import React from "react";

interface StackedDetailProps extends React.PropsWithChildren {
  labelI18nKey: string;
}

export const StackedDetail: React.FC<StackedDetailProps> = ({
  labelI18nKey,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="body2" className="row-start-1">
        {capitalize(t(labelI18nKey))}
      </Typography>
      <div className="row-start-2">{children}</div>
    </>
  );
};
